import { useRef } from 'react';
import { useLanguage } from './language-context';
import { useLayer } from './layer-stack';

// Pause-online confirmation (imported design pdPauseConfirm). Pausing hides the
// business from online booking, so it is a confirmed action — a centered card on
// desktop, a bottom sheet on mobile (reuses the .modal styles in dash.css). Resuming
// is immediate and never routes through here. A named single-purpose shell file.
export function PauseConfirmDialog({
  onKeep,
  onConfirm,
  busy,
}: {
  onKeep: () => void;
  onConfirm: () => void;
  busy?: boolean;
}) {
  const { t } = useLanguage();

  const panelRef = useRef<HTMLDivElement>(null);
  // Esc / Back keep the business online (top layer only, CB-17).
  useLayer(true, { kind: 'sheet', onDismiss: onKeep, containerRef: panelRef });

  return (
    <div className="modal-backdrop" onClick={onKeep}>
      <div
        ref={panelRef}
        className="modal modal--confirm"
        tabIndex={-1}
        role="alertdialog"
        aria-modal="true"
        aria-label={t('merchant.pause_confirm.title')}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="modal__title">{t('merchant.pause_confirm.title')}</h2>
        <p className="modal__body">{t('merchant.pause_confirm.body')}</p>
        <div className="modal__actions">
          <button type="button" className="btn btn--ghost" onClick={onKeep}>
            {t('merchant.pause_confirm.keep')}
          </button>
          <button type="button" className="btn btn--warn" disabled={busy} onClick={onConfirm}>
            {t('merchant.pause_online')}
          </button>
        </div>
      </div>
    </div>
  );
}
